/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import swal from 'sweetalert';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import calendarIcon from '../../atoms/customIcons/calendarIcon.svg';
import IconCustom from '../iconCustom/iconCustom';

export const LinkTheme = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  LIGH: 'ligh',
  DARK: 'dark',
  '': '',
};

export const LinkSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};


/**
 * Basic link component, it’s designed to edit the href attribute
 */
const ExternalLink = (props) => {
  const {
    id,theme, size, children, className, icon,customIcon, iconColor, iconSize, disabled, to,target,postUrl,swalTitle,swalText,onChange,hasClick,emptyValue
  } = props;
  const classProps = classNames(
    'btn',
    `btn-${theme}`,
    `btn-${size}`,
    className,
  );
  const handlerOnClick=(e,postUrl,to,enabled)=>{
    if(enabled){
    swal({
      title: swalTitle,
      text: swalText,
      buttons: true,
      dangerMode: true,    
    }).then((value) => {
      if(value==true){
        let url=postUrl+"/"+to;
        httpPost(url,{}).then((res)=>{
          onChange(e,res);
        });
      }
    });
   
  }
  }
  let newIcon=null;
  if(!postUrl){
    return(
      <> 
      {to && (hasClick==undefined || hasClick==true) && <a id={id}
      disabled={disabled}
      className={theme !== '' ? classProps : ''}
      href={to}
      target={(target?target:"_blank")}
      >
        { icon !== ''
          && (
          <Icon
            icon={icon}
            iconSize={iconSize}
            iconColor={iconColor}
          />
          )}
        {children}
      </a>}
    {!to && emptyValue==false && <span>(Empty)</span>}
    {!to && emptyValue==true && <span>{emptyValue}</span>}
    {to && hasClick==false && icon !== ''
         && (
         <Icon
           icon={icon}
           iconSize={iconSize}
           iconColor={iconColor}
         />
         )}
    </>
    );
  }else
    return (
      <>
      {customIcon==null && <a
        disabled={disabled}
        className={theme !== '' ? classProps : ''}
        onClick={(e)=>{handlerOnClick(e,postUrl,to,!disabled)}}
      >
      { icon !== '' && customIcon==null 
        && (
        <Icon
          icon={icon}
          iconSize={iconSize}
          iconColor={iconColor}
        />
        )}
      {children}
    </a>}
    {customIcon!=null && 
    <a id={id}
        className={theme !== '' ? classProps : ''} style={(customIcon.enabled?{"cursor":"pointer"}:null)}
        onClick={(e)=>{handlerOnClick(e,postUrl,to,customIcon.enabled)}}
      >
      {customIcon.customIcon && <IconCustom
          icon={customIcon.customIcon}
          iconSize={iconSize}
          iconColor={iconColor}
        />}
        {customIcon.icon && <Icon
          icon={customIcon.icon}
          iconSize={iconSize}
          iconColor={iconColor}
        />}
     
      {children}
    </a>
    }
    </>
    );
};

ExternalLink.propTypes = {
  /**
   * Link background color
   */
  theme: PropTypes.oneOf(Object.values(LinkTheme)),
  /**
   * Link general size
   */
  size: PropTypes.oneOf(Object.values(LinkSize)),
  /**
   * Content to put inside the link component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize link
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the link
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the link
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the link
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the link functionality
   */
  disabled: PropTypes.bool,
  /**
   * Link reference
   */
  // to: PropTypes.string.isRequired||PropTypes.number.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
};

ExternalLink.defaultProps = {
  theme: '',
  size: LinkSize.SMALL,
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
  hasClick:undefined
};

export default ExternalLink;
